import React from "react";
import { useDispatch } from "react-redux";
import { Avatar, Button, Col, Popover, Row } from "antd";
import { userSignOut } from "../../appRedux/actions";
import gambar from "./elogs_white.png";
import { PoweroffOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const UserProfile = () => {
  const dispatch = useDispatch();
  const pindah = useHistory();
  const jobdesk = localStorage.getItem("jobdesk");
  const fullname = localStorage.getItem(`fullname`);
  const cabang = localStorage.getItem("cabang");
  const loginBu = localStorage.getItem("loginBu");
  const username = localStorage.getItem("username");
  const initials = (fullname && fullname !== "undefined" ? fullname : (username || "U"))
    .split(" ")
    .map(n => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

  const userMenuOptions = (
    <div style={{ width: "220px", padding: "8px 4px", textAlign: "center" }}>
      {/* Profile Initials Circle */}
      <div style={{
        width: "48px",
        height: "48px",
        borderRadius: "50%",
        backgroundColor: "#fff0eb",
        color: "#ea5424",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "16px",
        fontWeight: "700",
        margin: "0 auto 12px auto",
        border: "1.5px solid #ffdcd0"
      }}>
        {initials}
      </div>

      {/* Name */}
      <h4 style={{ color: "#2d3748", fontWeight: "700", fontSize: "16px", margin: "0 0 2px 0", textTransform: "capitalize" }}>
        {fullname && fullname !== "undefined" ? fullname : username}
      </h4>

      {/* Role / Jobdesk Badge */}
      <span style={{
        display: "inline-block",
        backgroundColor: "#f7fafc",
        color: "#4a5568",
        padding: "2px 8px",
        borderRadius: "4px",
        fontSize: "11px",
        fontWeight: "600",
        textTransform: "uppercase",
        border: "1px solid #e2e8f0",
        marginBottom: "16px"
      }}>
        {jobdesk}
      </span>

      {/* Divider & Sign Out Button */}
      <div style={{ borderTop: "1px solid #edf2f7", paddingTop: "12px" }}>
        <Button
          type="primary"
          danger
          block
          style={{
            borderRadius: "6px",
            height: "34px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "600",
            border: "none",
          }}
          onClick={() => {
            if (loginBu === "RaceCabang") {
              localStorage.removeItem("token");
              localStorage.removeItem("loginBu");
              localStorage.removeItem("jobdesk");
              localStorage.removeItem("cabang");
              localStorage.removeItem("level");
              localStorage.removeItem("mitra1");
              localStorage.removeItem("IdDriver");
              localStorage.removeItem("mitra2");
              localStorage.removeItem("fullname");
              localStorage.removeItem("idkodekendaraan1");
              localStorage.removeItem("idkodekendaraan2");
              localStorage.removeItem("idcustomer");
              localStorage.removeItem("kendaraan");
              localStorage.removeItem("IdDriver2");
              pindah.push("/login/race/customer");
            }
            dispatch(userSignOut());
          }}
        >
          <PoweroffOutlined style={{ marginRight: "6px", fontSize: "14px" }} /> Sign Out
        </Button>
      </div>
    </div>
  );

  return (
    <div className="gx-flex-row gx-align-items-center gx-avatar-row" style={{ lineHeight: "normal" }}>
      <Popover
        placement="bottomRight"
        content={userMenuOptions}
        trigger="click"
      >
        <div style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", whiteSpace: "nowrap" }}>
          <span style={{ fontSize: "14px", fontWeight: "600", color: "#2d3748" }}>
            Admin {jobdesk}
          </span>
          <i className="icon icon-chevron-down gx-fs-xs icons" style={{ fontSize: "12px", color: "#2d3748", display: "flex", alignItems: "center" }} />
        </div>
      </Popover>
    </div>
  );
};

export default UserProfile;
